import { render, staticRenderFns } from "./DokmanComponentMeinBereichMainTable.vue?vue&type=template&id=7156cb0f&scoped=true"
import script from "./DokmanComponentMeinBereichMainTable.vue?vue&type=script&lang=js"
export * from "./DokmanComponentMeinBereichMainTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7156cb0f",
  null
  
)

export default component.exports